/* eslint-disable */
import React from 'react'
import { BookingTailwindModal } from './Booking/BookingTailwindModaal';

const BookingEditModal = ({ isOpen2, setIsOpen2, selectedId, type }) => {
    const handleClose = () => setIsOpen2(false);

    return (
        <div className='flex justify-center overflow-hidden top-[-40px]'>
            <BookingTailwindModal isOpen={isOpen2} handleClose={handleClose} selectedId={selectedId} type={type} />
        </div>
    )
}

export default BookingEditModal;